<template>
	<div class="flex items-center justify-center gap-1">
		<div
			v-for="(_, i) in count"
			class="h-1 w-3 rounded-full"
			:class="{
				'bg-label-secondary': i === active,
				'bg-separator-secondary': i !== active
			}"
		/>
	</div>
</template>
<script setup lang="ts">
defineProps<{
	count: number
	active: number
}>()
</script>
